import {
  fetchStationDetail,
  fetchLocationData,
  fetchCurrentCongestionRate,
  fetchCongestionTrend,
  receiveStationDetail,
  receiveLocationData,
  receiveCurrentCongestionRate,
  receiveCongestionTrend,
} from '../actions'
import { connect } from 'react-redux'
import { showAlert } from '../utils/Alert'
import StationViewDetail from '../components/station_view/StationViewDetail'

const mapStateToProps = (state, _props) => {
  const { station } = state.stationReducer
  const { locations, currentCongestions, congestionTrends } = state.stationViewReducer
  const { themeName } = state.themeReducer

  return {
    station,
    locations,
    currentCongestions,
    congestionTrends,
    themeName,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchStationDetail: async (stationId) => {
      try {
        const payload = await fetchStationDetail(stationId)
        dispatch(receiveStationDetail(payload))
      } catch (error) {
        showAlert("駅情報が取得できませんでした")
      }
    },
    fetchLocationData: async (stationId, locationId) => {
      try {
        const payload = await fetchLocationData(stationId, locationId)
        dispatch(receiveLocationData(payload, locationId))
      } catch (error) {
        showAlert("カメラデータが取得できませんでした")
      }
    },
    fetchCurrentCongestionRate: async (stationId, locationId) => {
      try {
        const payload = await fetchCurrentCongestionRate(stationId, locationId)
        dispatch(receiveCurrentCongestionRate(payload, locationId))
      } catch (error) {
        showAlert("現在の混雑度データが取得できませんでした")
      }
    },
    fetchCongestionTrend: async (stationId, locationId) => {
      try {
        const payload = await fetchCongestionTrend(stationId, locationId)
        dispatch(receiveCongestionTrend(payload, locationId))
      } catch (error) {
        showAlert("混雑度傾向のデータが取得できませんでした")
      }
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationViewDetail)